import {
    useMemo, Dispatch, SetStateAction,
} from 'react'
import {
    State,
} from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemoCreateQuote/useContractBasisCreateQuoteReducer'
import {
    TypeWithId,
} from 'app/Apps/Pricing/ContractBasis/utils/createQuote.types'
import DemoAddFeesLaneGroupsForm
    from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemoCreateQuote/steps/SelectAddFeesLaneGroupStep/DemoAddFeesLaneGroupsForm'
import Button from 'app/shared-components/Button'
import Tooltip from 'app/shared-components/Tooltip'

import useContractBasisCreateQuoteContext
    from '../../ContractBasisCreateQuoteContext'

export default function SelectAddFeesLaneGroupStep({
    setAdditionalFee,
    setLaneGroups,
    classes,
    state,
}: Readonly<{
    state: State,
    setAdditionalFee: Dispatch<SetStateAction<TypeWithId>>,
    setLaneGroups: Dispatch<SetStateAction<TypeWithId[]>>,
    classes: Record<string, string>
}>) {
    const {
        setActiveStep,
        activeStep,
        contractBasisId,
        quoteId,
    } = useContractBasisCreateQuoteContext()

    const {
        additionalFee, laneGroups,
    } = state

    const isAddFeeAndLaneGroupsSelected = useMemo((): boolean => {
        return !!(additionalFee && laneGroups?.length > 0)
    }, [
        additionalFee,
        laneGroups,
    ])

    return (
        <div>
            <DemoAddFeesLaneGroupsForm
                disabled={activeStep !== 0}
                id={contractBasisId}
                setAdditionalFee={setAdditionalFee}
                setLaneGroups={setLaneGroups}
                quoteId={quoteId}
            />
            <div>
                {activeStep === 0 && (
                    <Tooltip
                        title="Please select an Additional Fee and Lane Group"
                        disabled={isAddFeeAndLaneGroupsSelected}
                    >
                        <div className={classes.buttonWrapper}>
                            <Button
                                label="Continue"
                                onClick={() => {
                                    setActiveStep(1)
                                }}
                                className={classes.button}
                                disabled={!isAddFeeAndLaneGroupsSelected}
                            />
                        </div>
                    </Tooltip>
                )}
                {activeStep !== 0 && (
                    <Button
                        label="Edit"
                        onClick={() => {
                            setActiveStep(0)
                        }}
                        className={classes.button}
                    />
                )}
            </div>
        </div>
    )
}
